import type { Strings } from '../index.ts';

/**
 * Der Rahmen, in dem jede Seite sitzt: die Navigation, das Suchfeld, der Konto-Knopf, der Offline-Hinweis.
 *
 * Die Navigationsnamen sind nach der `NavDestinationId` von core geordnet, und die Anmeldeseite liest
 * dieselbe Tabelle, damit „dort, wo du hinwolltest“ in beiden gleich geschrieben ist.
 *
 * `placeholder.plannedInSliceBefore` und `openOnBefore` sind Satzköpfe: dahinter beginnt ein Element (ein
 * gestylter Hinweis, eine Liste von Links), und der Punkt danach steht in der View, weil ein Punkt nichts
 * zu übersetzen ist.
 */
export const shell: Strings['shell'] = {
  brand: 'Visious',
  brandTitle: 'Visious-Startseite',
  skipToContent: 'Zum Inhalt springen',

  nav: {
    label: 'Bereiche',
    popular: 'Beliebt',
    trending: 'Trends',
    subscriptions: 'Abos',
    playlists: 'Playlists',
    history: 'Verlauf',
    lockedTitle: (destination) => `Melde dich bei deiner Instanz an, um ${destination} zu benutzen`,
    signInNeeded: 'Anmeldung nötig',
  },

  search: {
    label: 'Suche',
    placeholder: 'Suchen, oder einen Link einfügen',
    clear: 'Suche löschen',
    submit: 'Suchen',
  },

  account: {
    unknown: 'Konto',
    signIn: 'Anmelden',
    signedInTitle: 'Deine Sitzung auf dieser Instanz',
    signedOutTitle:
      'Melde dich bei deiner Instanz an, um Abos, Playlists und Verlauf zu benutzen',
  },

  settings: 'Einstellungen',

  theme: {
    toLight: 'Zum hellen Design wechseln',
    toDark: 'Zum dunklen Design wechseln',
  },

  offline:
    'Du bist offline. Visious selbst öffnet sich weiterhin, aber alles darin kommt von deiner Instanz, deshalb kann unten nichts laden, bis die Verbindung zurück ist.',

  sessionExpiry: {
    /* `when` kommt fertig formatiert an („in 2 Tagen“), der Satz beugt also nie ein Datum. Das trennbare
       „läuft … ab“ nimmt die Zeitangabe in die Mitte, was im Deutschen die natürliche Stelle ist. */
    text: (when) =>
      `Deine Sitzung läuft ${when} ab. Eine neue Anmeldung hält deine Abos, Playlists und deinen Verlauf erreichbar.`,
    renew: 'Jetzt erneuern',
    dismiss: 'Nicht jetzt',
  },

  confirm: 'Bestätigen',

  state: {
    retry: 'Erneut versuchen',
  },

  boundary: {
    title: 'Diese Seite konnte nicht gezeichnet werden',
    detailBefore:
      'Beim Zeichnen ist in Visious etwas schiefgegangen, und das ist ein Fehler hier und nichts, was deine Instanz getan hat. Alles andere funktioniert weiter, und die Navigation oben ist aktiv. Der Fehler war:',
    retry: 'Erneut zeichnen versuchen',
  },

  placeholder: {
    plannedInSliceBefore: 'Geplant für',
    openOnBefore: 'Öffne es auf',
    backToStart: 'Zurück zum Anfang',
  },

  notFound: {
    title: 'Hier ist nichts',
    detail: (path) =>
      `${path} passt zu nichts in Visious. Entweder benennt es nichts, oder die ID darin hat die falsche Form.`,
  },
  post: {
    title: 'Community-Beiträge werden nicht unterstützt',
    detail:
      'Das ist ein echter Community-Beitrag und der Link ist gut. Visious kann sie nur noch nicht zeigen.',
  },
};
